import { Id, PriceList } from '@typings';
import { createAction } from 'typesafe-actions';

export const fetchPricelistsRequest = createAction('pricelists/FETCH_Pricelists_REQUEST')();
export const fetchPricelistsSuccess = createAction('pricelists/FETCH_Pricelists_SUCCESS')<PriceList[]>();
export const fetchPricelistsFailure = createAction('pricelists/FETCH_Pricelists_FAILURE')();

export const setCurrentPricelist = createAction('pricelists/SET_CURRENT_PRICE_LIST')<Id>();
